import { useMutation, useQueryClient } from "react-query";
import { DeleteWorkspaceGroupData } from "@interfaces/company/workspace";
import { workspaceService } from "@services/workspace-service";
import { workspaceQueryKeys } from "./queryKeys";

export const useDeleteWorkspaceGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: DeleteWorkspaceGroupData) => workspaceService.deleteGroup(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allGroups);
      },
    }
  );
};
